import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.PERMISSIONAMENTO.VERIFICAR_PERMISSOES_DO_USUARIO_NO_ORGAO]({ state: { idOrgao, permissoes } }) {
		const { data } = await api.permissionamento.verificarPermissoesDoUsuarioNoOrgao(idOrgao, permissoes)
		return data
	},
}
